import { useCallback } from 'react';
import { utils } from '..';

/**
 * This hook allows us to debounce any fast changing value. The debounced value will only reflect
 * the latest value when the useDebounce hook has not been called for the specified time period.
 */
const useDebounce = (func: any, delay: any = 500) =>
  useCallback(
    utils.debounce((inputValue: string, callback: any) => {
      func(inputValue).then((options: any) => callback(options));
    }, delay),
    []
  );

export default useDebounce;
